import { render, staticRenderFns } from "./HepsiLojistikComponent.vue?vue&type=template&id=6daea6f1"
import script from "./HepsiLojistikComponent.vue?vue&type=script&lang=js"
export * from "./HepsiLojistikComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports